import { memo, useMemo } from 'react';
import { useTranslation, Trans } from '@betty/i18n';
import { Box, Button, Text } from '@betty/moonlight';
import { getFooterTransOptions } from './Footer.utils';
import { FooterProps } from './Footer.types';

function Footer({
  promos,
  loading,
  disabled,
  selectedAmount,
  selectedPromoIds,
  onButtonPress,
  ...rest
}: FooterProps) {
  const { t } = useTranslation('wallet');
  const transOptions = useMemo(
    () =>
      getFooterTransOptions(t, selectedPromoIds, promos, selectedAmount).filter(
        Boolean,
      ),
    [promos, selectedAmount, selectedPromoIds, t],
  );
  const transComponents = useMemo(
    () => ({
      freeSpinsGame: <Text variant="body-m" color="darkSurfacePrimary" />,
    }),
    [],
  );

  return (
    <Box
      position="absolute"
      left="space-0"
      right="space-0"
      bottom="space-0"
      padding="space-400"
      paddingBottom="safe-area-inset-bottom"
      centerContent
      {...rest}
    >
      <Box
        position="absolute"
        backgroundColor="secondaryBackground"
        opacity={0.9}
        inset={0}
      />
      <Box width="90%">
        <Text
          variant="body-m"
          locNS="wallet"
          locKey="depositContinueWith"
          color="darkSurfacePrimary"
        />
        {transOptions.map((options, index) => (
          <Text key={index} variant="body-m-semi" color="darkSurfacePrimary">
            <Trans components={transComponents} {...options} />
          </Text>
        ))}
        <Button
          locNS="common"
          locKey="next"
          size="small"
          alignSelf="center"
          rightIcon="arrowForward"
          marginTop="space-200"
          width="100%"
          loading={loading}
          disabled={disabled}
          onPress={onButtonPress}
        />
      </Box>
    </Box>
  );
}

export default memo(Footer);
